/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DashboardUserDtoFromJSON, DashboardUserDtoToJSON, } from './DashboardUserDto';
/**
 * Check if a given object implements the DashboardUserListDto interface.
 */
export function instanceOfDashboardUserListDto(value) {
    return true;
}
export function DashboardUserListDtoFromJSON(json) {
    return DashboardUserListDtoFromJSONTyped(json, false);
}
export function DashboardUserListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'userList': json['userList'] == null ? undefined : (json['userList'].map(DashboardUserDtoFromJSON)),
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}
export function DashboardUserListDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'userList': value['userList'] == null ? undefined : (value['userList'].map(DashboardUserDtoToJSON)),
        'totalElements': value['totalElements'],
    };
}
